<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <span class="font" style="display: flex; align-items: center"
        >{{ type == "add" ? "新增" : "编辑" }}资讯文章
      </span>
    </div>

    <div class="center" style="position: relative">
      <el-form
        ref="formTool"
        :rules="rules"
        :model="formTool"
        label-position="right"
        label-width="120px"
      >
        <el-form-item prop="articleTitle" label="资讯标题">
          <el-input
            v-model="formTool.articleTitle"
            :disabled="type == 'detail'"
            type="textarea"
            style="width: 400px"
            maxlength="50"
            show-word-limit
            placeholder="请输入资讯标题"
            clearable
            size="small"
          />
        </el-form-item>
        <el-form-item prop="articleThreeClassificationId" label="资讯分类">
          <el-select
            v-model="formTool.articlePrimaryClassificationId"
            :disabled="type == 'detail'"
            value-key="id"
            @change="changeSortOne"
            clearable
            @clear="clearSortOne"
            style="width: 130px"
            size="small"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsOne"
              :key="item.id"
              :label="item.label"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formTool.articleSecondaryClassificationId"
            :disabled="type == 'detail'"
            value-key="id"
            @change="changeSortTwo"
            clearable
            @clear="clearSortTwo"
            style="margin-left: 10px; width: 130px"
            size="small"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsTwo"
              :key="item.id"
              :label="item.label"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formTool.articleThreeClassificationId"
            :disabled="type == 'detail'"
            @change="changeSortThree"
            clearable
            @clear="clearSortThree"
            value-key="id"
            style="margin-left: 10px; width: 130px"
            size="small"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsThree"
              :key="item.id"
              :label="item.label"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="publishingPlatform" label="发布平台">
          <el-checkbox-group
            v-model="formTool.publishingPlatform"
            :disabled="type == 'detail'"
          >
            <el-checkbox label="商户端" :disabled="salesFlag"></el-checkbox>
            <el-checkbox label="客户端" :disabled="clientFlag"></el-checkbox>
            <el-checkbox label="业务端" :disabled="businessFlag"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="releaseTime" label="计划发布时间">
          <el-date-picker
            v-model="formTool.releaseTime"
            :disabled="type == 'detail'"
            :picker-options="pickerOptions"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="pinnedStatus" label="是否置顶">
          <el-checkbox-group v-model="formTool.pinnedStatus" :disabled="type == 'detail'">
            <el-checkbox label="置顶"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="sort" label="排序">
          <el-input-number
            class="sort-input-number"
            v-model="formTool.sort"
            placeholder="请输入排序"
            controls-position="right"
            size="small"
            :min="1"
            :max="9999"
            style="width: 400px"
          ></el-input-number>
        </el-form-item>
        <el-form-item prop="informationContent" label="资讯内容">
          <wangEnduit
            ref="wangEnduit"
            :value="formTool.informationContent"
            :isDisabled="type == 'detail'"
            :is-clear="isClear"
            @changeEndit="watchEndit"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="cancel()">取消</el-button>
          <el-button
            size="small"
            v-if="type != 'detail'"
            style="margin-left: 16px"
            type="primary"
            @click="article('DRAFT')"
            >保存草稿</el-button
          >
          <el-button
            size="small"
            v-if="type != 'detail'"
            style="margin-left: 16px"
            type="primary"
            @click="article('PUBLISH')"
            >保存并发布</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import wangEnduit from "@/components/wangEnduit";
import {
  queryInformationClassifyByParentId,
  article,
  queryInformationArticleById,
  editArticle,
  queryInformationClassifyByParentIdByWCB
} from "@/api/message/InformationClassification";

export default {
  name: "WareProduct",
  components: { wangEnduit },
  data() {
    return {
      isClear: false, // 清除富文本编辑内容
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 3600 * 24 * 1000;
        },
      },
      type: "",
      sortOne: "",
      sortTwo: "",
      sortThree: "",
      optionsOne: [],
      optionsTwo: [],
      optionsThree: [],
      formTool: {
        pinnedStatus: "",
        articleTitle: "",
        publishingPlatform: [],
        releaseTime: "",
        informationContent: "",
        articlePrimaryClassificationId: "",
        articleSecondaryClassificationId: "",
        articleThreeClassificationId: "",
      },
      rules: {
        articleTitle: [{ required: true, message: "请输入资讯标题", trigger: "blur" }],
        informationContent: [
          { required: true, message: "请输入资讯内容", trigger: "blur" },
        ],
        publishingPlatform: [
          { required: true, message: "请选择发布平台", trigger: "change" },
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        articleThreeClassificationId: [
          { required: true, message: "请选择资讯分类", trigger: "change" },
          { required: true, message: "请选择资讯分类", trigger: "blur" },
        ],
      },
      salesFlag: false, // 商户端是否禁用
      clientFlag: false, // 客户端是否禁用
      businessFlag: false, // 业务端是否禁用
    };
  },
  computed: {},
  watch: {},
  async created() {
    this.type = this.$route.query.type;
    if (this.$route.query.type != "add") {
      this.queryInformationArticleById(this.$route.query.id);
    } else {
      this.queryInformationClassifyByParentId(0, "0");
    }
  },
  mounted() {
    this.$refs.wangEnduit.editor.disable();
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    watchEndit(val) {
      // 监听富文本编辑传过来的数据
      this.formTool.informationContent = val;
    },
    // 编辑
    editHandle(params) {
      params.id = this.$route.query.id;
      editArticle(params).then((res) => {
        if (res) {
          this.$message.success("编辑成功");
          this.cancel();
        }
      });
    },
    // 新增
    article(status) {
      let params = {
        ...this.formTool,
        status: status,
      };
      params.articlePrimaryClassificationName =
        params.articlePrimaryClassificationId.label;
      params.articleSecondaryClassificationName =
        params.articleSecondaryClassificationId.label;
      params.articleThreeClassificationName = params.articleThreeClassificationId.label;
      params.articlePrimaryClassificationId = params.articlePrimaryClassificationId.id;
      params.articleSecondaryClassificationId =
        params.articleSecondaryClassificationId.id;
      params.articleThreeClassificationId = params.articleThreeClassificationId.id;
      params.pinnedStatus = params.pinnedStatus ? "1" : "0";
      params.releaseTime = params.releaseTime ? params.releaseTime : "";
      params.publishingPlatform =
        params.publishingPlatform.length > 0 ? params.publishingPlatform.join() : "";
      if (params.status == "PUBLISH" && params.releaseTime) {
        // params.status = 'RELEASED'
        // if (new Date(params.releaseTime).getTime() <= Date.now()) {
        //   this.$message.warning('发布时间不能早于当前时间')
        //   return
        // }
      }
      this.$refs.formTool.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            article(params).then((res) => {
              if (res) {
                this.$message.success("新增成功");
                this.cancel();
              }
            });
          } else {
            this.editHandle(params);
          }
        }
      });
    },
    // 下拉选择改变
    changeSortOne(value) {
      if (value) {
        const currentList = this.optionsOne.filter((item) => item.id == value.id);
        if (currentList.length) {
          this.formTool.publishingPlatform = currentList[0].operationAuthority.split(",");
          if (currentList[0].operationAuthority) {
            const str = currentList[0].operationAuthority;
            this.salesFlag = !str.includes("商户端");
            this.clientFlag = !str.includes("客户端");
            this.businessFlag = !str.includes("业务端");
          }
        }

        this.formTool.articleSecondaryClassificationId = undefined;
        this.formTool.articleThreeClassificationId = undefined;
        this.queryInformationClassifyByParentId(value.id, "1");
      } else {
        this.formTool.articleSecondaryClassificationId = undefined;
        this.formTool.articleThreeClassificationId = undefined;
        this.optionsTwo = [];
        this.optionsThree = [];
      }
    },
    // 下拉选择改变
    changeSortTwo(value) {
      if (value) {
        const currentList = this.optionsTwo.filter((item) => item.id == value.id);
        if (currentList.length) {
          this.formTool.publishingPlatform = currentList[0].operationAuthority.split(",");
          if (currentList[0].operationAuthority) {
            console.log("二级", currentList);
            const str = currentList[0].operationAuthority;
            this.salesFlag = !str.includes("商户端");
            this.clientFlag = !str.includes("客户端");
            this.businessFlag = !str.includes("业务端");
          }
        }

        this.formTool.articleThreeClassificationId = undefined;
        this.queryInformationClassifyByParentId(value.id, "2");
      } else {
        this.formTool.articleThreeClassificationId = undefined;
        this.optionsThree = [];
      }
    },
    changeSortThree(value) {
      if (value) {
        const currentList = this.optionsThree.filter((item) => item.id == value.id);
        if (currentList.length) {
          this.formTool.publishingPlatform = currentList[0].operationAuthority.split(",");
          if (currentList[0].operationAuthority) {
            console.log("三级", currentList);
            const str = currentList[0].operationAuthority;
            this.salesFlag = !str.includes("商户端");
            this.clientFlag = !str.includes("客户端");
            this.businessFlag = !str.includes("业务端");
          }
        }
      }
    },
    clearSortOne() {
      this.salesFlag = false; // 商户端是否禁用
      this.clientFlag = false; // 客户端是否禁用
      this.businessFlag = false; // 业务端是否禁用
      this.formTool.publishingPlatform = [];
    },
    clearSortTwo() {
      const { articlePrimaryClassificationId } = this.formTool;
      if (articlePrimaryClassificationId && articlePrimaryClassificationId.id) {
        const currentList = this.optionsOne.filter(
          (item) => item.id == articlePrimaryClassificationId.id
        );
        this.formTool.publishingPlatform = currentList[0].operationAuthority.split(",");
        const str = currentList[0].operationAuthority;
        this.salesFlag = !str.includes("商户端");
        this.clientFlag = !str.includes("客户端");
        this.businessFlag = !str.includes("业务端");
      } else {
        this.formTool.publishingPlatform = [];
      }
    },
    clearSortThree() {
      const { articleSecondaryClassificationId } = this.formTool;
      if (articleSecondaryClassificationId && articleSecondaryClassificationId.id) {
        const currentList = this.optionsTwo.filter(
          (item) => item.id == articleSecondaryClassificationId.id
        );
        this.formTool.publishingPlatform = currentList[0].operationAuthority.split(",");
        const str = currentList[0].operationAuthority;
        this.salesFlag = !str.includes("商户端");
        this.clientFlag = !str.includes("客户端");
        this.businessFlag = !str.includes("业务端");
      } else {
        this.formTool.publishingPlatform = [];
      }
    },
    // 查询三级分类
    async queryInformationClassifyByParentId(id, type) {
      queryInformationClassifyByParentIdByWCB(id).then((res) => {
        if (type == "0") {
          if (res.length > 0) {
            this.optionsOne = [];
            res.forEach((item) => {
              this.optionsOne.push({
                id: item.id,
                label: item.classifyName,
                operationAuthority: item.operationAuthority,
              });
            });
          }
        } else if (type == "1") {
          this.optionsTwo = [];
          res.forEach((item) => {
            this.optionsTwo.push({
              id: item.id,
              label: item.classifyName,
              operationAuthority: item.operationAuthority,
            });
          });
        } else if (type == "2") {
          this.optionsThree = [];
          res.forEach((item) => {
            this.optionsThree.push({
              id: item.id,
              label: item.classifyName,
              operationAuthority: item.operationAuthority,
            });
          });
        }
      });
    },
    // 取消
    cancel() {
      this.$router.back(-1);
    },
    // 查询详情
    queryInformationArticleById(id) {
      queryInformationArticleById(id).then((res) => {
        // status
        this.formTool.pinnedStatus = res.pinnedStatus == "1" ? true : false;
        this.formTool.informationContent = res.informationContent;
        this.formTool.articleTitle = res.articleTitle;
        this.formTool.publishingPlatform = res.publishingPlatform
          ? res.publishingPlatform.split(",")
          : [];
        this.formTool.releaseTime = res.releaseTime;
        this.formTool.articlePrimaryClassificationId = {
          label: res.articlePrimaryClassificationName,
          id: res.articlePrimaryClassificationId,
        };
        this.formTool.articleSecondaryClassificationId = {
          label: res.articleSecondaryClassificationName,
          id: res.articleSecondaryClassificationId,
        };
        this.formTool.articleThreeClassificationId = {
          label: res.articleThreeClassificationName,
          id: res.articleThreeClassificationId,
        };
        this.formTool.sort = res.sort;
        this.queryInformationClassifyByParentId(0, "0");
        this.queryInformationClassifyByParentId(res.articlePrimaryClassificationId, "1");
        this.queryInformationClassifyByParentId(
          res.articleSecondaryClassificationId,
          "2"
        );
        console.log(this.formTool, "formtool");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.classification {
  padding: 0px;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 0 24px;
  // height: calc(100% - 131px);
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shangjia {
    position: absolute;
    z-index: 2;
    bottom: -45px;
  }
}
.sort-input-number {
  ::v-deep.el-input-number .el-input__inner {
    text-align: left;
  }
}
</style>
